import { ExperimentState } from './generated/graphql.js';
import { ExperimentService } from './service.js';
import doc from './ExperimentsUpdatedAfter.gql.js';

function createClient(options) {
    const { apolloClient: client } = options;
    const apolloClient = typeof client !== 'function' ? () => client : client;
    return apolloClient()
        .query({
        query: doc,
        fetchPolicy: 'no-cache'
    })
        .then(({ data, errors }) => {
        if (!data) {
            return Promise.reject(errors);
        }
        const updatedUntil = data.experimentsUpdatedAfter.experiments
            .map(experiment => Date.parse(experiment.updatedAt))
            .reduce((a, b) => (a < b ? b : a), 0);
        const experiments = new Map(data.experimentsUpdatedAfter.experiments
            .filter(experiment => experiment.state == ExperimentState.ACTIVE)
            .map(experiment => [experiment.name, experiment]));
        const state = { updatedUntil, experiments };
        // Periodic refresh
        setInterval(() => {
            apolloClient()
                .query({
                query: doc,
                variables: {
                    updatedAfter: new Date(state.updatedUntil)
                },
                fetchPolicy: 'no-cache'
            })
                .then(({ data, errors }) => {
                if (!data) {
                    return Promise.reject(errors);
                }
                state.updatedUntil = data.experimentsUpdatedAfter.experiments
                    .map(experiment => Date.parse(experiment.updatedAt))
                    .reduce((a, b) => (a < b ? b : a), state.updatedUntil);
                const updates = new Map(data.experimentsUpdatedAfter.experiments
                    .filter(experiment => experiment.state == ExperimentState.ACTIVE)
                    .map(experiment => [experiment.name, experiment]));
                state.experiments = new Map([...state.experiments, ...updates]);
            });
        }, options.fetchUpdatesIntervalMillis);
        return new ExperimentService(state);
    });
}

export { createClient };
//# sourceMappingURL=index.js.map
